import { type FormEvent, useEffect, useState } from 'react';

import { Button } from '@/components/ui/button.tsx';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog.tsx';
import { Input } from '@/components/ui/input.tsx';
import { useSessionStore } from '@/hooks/use-session-store/use-session-store';
import { LOGGER_ACTIONS, logger } from '@/lib/logger';

export function ProductSelectionSubmitFeedback({ currentCategory }: { currentCategory?: string }) {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');

  useEffect(() => {
    logger.action(LOGGER_ACTIONS.INTAKE.NO_PRODUCTS_SELECTED);
  }, []);

  const handleFeedbackOpenChange = (open: boolean) => {
    setFeedbackOpen(open);
    if (!open) {
      setFeedbackText('');
    }
  };

  const handleSubmitFeedback = (e: FormEvent) => {
    e.preventDefault();

    logger.action(LOGGER_ACTIONS.INTAKE.REQUEST_COVERED_SUPPLIES, {
      categories_selected: useSessionStore.getState().selectedCategoryIds,
      current_category: currentCategory,
      text: feedbackText,
    });

    handleFeedbackOpenChange(false);
  };

  return (
    <>
      <p className="text-center">
        Can’t find what you need?{' '}
        <Button
          type="button"
          variant="link"
          size="link"
          className="inline-flex"
          onClick={() => setFeedbackOpen(true)}
        >
          Let us know
        </Button>
      </p>

      <Dialog open={feedbackOpen} onOpenChange={handleFeedbackOpenChange}>
        <DialogContent className="max-w-[364px] gap-6">
          <DialogHeader>
            <DialogTitle>Tell us what you need</DialogTitle>
            <DialogDescription className="font-circular text-base leading-6 text-foreground">
              Your feedback helps us add new covered supplies. We&apos;d love to hear what
              you&apos;re looking for.
            </DialogDescription>
          </DialogHeader>
          <form className="flex flex-col gap-6" onSubmit={handleSubmitFeedback}>
            <Input
              autoComplete="off"
              onChange={(e) => setFeedbackText(e.target.value)}
              placeholder="Example: overnight briefs, folding cane"
              value={feedbackText}
            />
            <Button type="submit">Submit feedback</Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
